import ApiService from "@/core/services/api.service";
import {settingData,Calender} from "@/types/settingData"
export const GETSETTINGLIST = "getSettingList";
export const GETSETTINGSYSTEMINFOLIST = "getSystemInfo";
export const GETWEBINFO = "getWebInfo";
export const ADDSETTINGLIST = "addSettingList";
export const SET_SETTINGRESSULT = "setSettingResult";
export const SET_SETTINGERROR = "setSettingError";
export const SETSETTINGLIST = "setSettingList";
export const SET_GETWEBINFO = "setGETWEBINFO";
export const SET_CURRENTLOCAL = "setCurrentLcoal";
export const TOGGELCUREENTLOCAL = "toggleCurrentLcoal";
type State = {
  result_getWebInfo: null,
  errors: [],
  messages: [],
  settingData:settingData;
  currentLocale;
};
const state: State = {
  result_getWebInfo: null,
  errors: [],
  messages: [],
  settingData:{
    multilingual: false,
    calender: Calender.English
  },
    currentLocale:'en'
};
const getters = {
  getWebInfo(state) {
    return state.result;
  },
  getSettingErrors() {
    return state.errors;
  },
  getSettingMessages(state) {
    return state.messages;
  },
  getSettingData(state) {    
    return state.settingData;
  },
  getCurrentLocale(state) {    
    return state.currentLocale;
  }
};
const actions = {
  [ADDSETTINGLIST](context, body) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post("/definition/Setting/savesetting", body)
        .then(({ data }) => {
          context.commit(SET_SETTINGRESSULT, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_SETTINGERROR, response.data.errors);
        });
    });
  },
  [GETSETTINGLIST](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.getData("/system/Setting/getall")
        .then(({ data }) => {
         context.commit(SETSETTINGLIST, data.data, []);         
        })
        .catch(({ response }) => {
          context.commit(SET_SETTINGERROR, response.data.errors);
        });
    });
  },
  [GETWEBINFO](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.getData("/definition/Setting/getwebsiteinfo")
        .then(({ data }) => {
          context.commit(SET_GETWEBINFO, data, []);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_SETTINGERROR, response.data.errors);
        });
    });
  },
  [GETSETTINGSYSTEMINFOLIST](context,token) {
    return new Promise((resolve) => {
      // @ts-ignore
      ApiService.setHeader(token);
      ApiService.getData("/system/getapplicationsetting")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_SETTINGERROR, response.data.errors);
        });
    });
  },
   [TOGGELCUREENTLOCAL](context) {
   var currentLocale = state.currentLocale === "fa" ? "en" : "fa"; 
    context.commit(SET_CURRENTLOCAL, currentLocale);
  },
};

const mutations = {
  [SET_SETTINGERROR](state, error) {
    state.errors = error;
  },
  [SET_SETTINGRESSULT](state, apiResult) {
    if (apiResult.isSuccessful) {
      state.settingData = apiResult.message;
      state.errors = [];
    } else {
      state.errors = apiResult.message;
      state.settingDate = [];
    }
  },
  [SETSETTINGLIST](state, apiResult) {
    state.settingData = {...state.settingData,  ...apiResult };
    state.currentLocale = state.settingData.calender == '1' ? 'en' : 'fa'//to do in feature implements multiy 
    if (apiResult.isSuccessful) {
      state.errors = [];
    } else {
      state.errors = apiResult.message;
    }
  },
  [SET_GETWEBINFO](state, apiResult) {
    if (apiResult.isSuccessful) {
      state.result_getWebInfo = apiResult.data;
      state.errors = [];
      state.messages = apiResult.message;
    } else {
      state.result_getWebInfo = [];
      state.errors = apiResult.message;
      state.messages = [];
    }
  },
   [SET_CURRENTLOCAL](state, value) {
    state.currentLocale = value;
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
